import React, {Component} from "react";
import CmModal from "../../../../../components/CmModal/CmModal";
import CmForm from "../../../../../components/CmForm/CmForm";
import {Form, Input, Radio, Checkbox, Button, Popconfirm, Icon} from "antd";
import {message} from "../../../utils/sysManagementUtils";
import BaseComponent from "../../../../../base/BaseComponent";
import RoleSelect from "../../role/roleSelect/RoleSelect";
import DeptSelectModal from "../../dept/deptSelectModal/DeptSelectModal";
import {validateName, validateNumber} from "../../../../../utils";
import {accountValidate} from "../../../../../utils/validate";
import {Scrollbars} from "react-custom-scrollbars";
import $ from 'jquery'
import { Tooltip } from "antd";
import SelectUserModal from "../../../../newUserManagement/components/SelectUserModal";

export default class EditUserModal extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            editUser: null,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible) {
            // 如果有data 代表修改
            const params = this.props.data || {};
            const level = this.props.level || {};
            //代表新增
            if (!params.id) {
                params.deptIds = this.props.selectedKeys;
            }
            if (!params.deptRoles) {
                if (params.deptIds || params.roleCodes) {
                    params.deptRoles = [{
                        "deptId": params.deptIds[0] || '',
                        "roleCodes": params.roleCodes || [],
                        "status": params.status || 1,
                    }]
                }
            }
            this.setState({
                editUser: initUser(params,level)
            });
        }
    }

    render() {
        const {
            editUser,
        } = this.state;

        if (!editUser) {
            return null;
        }

        const {
            title,
            visible
        } = this.props;
        let webSiteDataSource=this.props.webSiteDataSource||[];

        const onUserChange = this.onUserChange;

        const ifAdd = !editUser.id.value;
        // 判断至少有一个不可禁用
        let flag = false;
        let num = 0;
        editUser && editUser.deptRoles && editUser.deptRoles.map((item, index) => {
            if (item.status === 1) {
                num += 1;
            }
            if (num <= 1) {
                flag = true;
            } else {
                flag = false;
            }
        });
        return (
            <>
                <CmModal
                    visible={visible}
                    title={title}
                    handleOk={this.handleOk}
                    handleCancel={this.handleCancel}
                    destroyOnClose={true}
                >
                    <CmForm>
                        <Scrollbars style={{height: ifAdd ? 475 : 435}} autoHide
                                    onScroll={
                                        () => {
                                            // $('.ant-select-dropdown').addClass('ant-select-dropdown-hidden');
                                            // $('.ant-select').removeClass('ant-select-focused ant-select-open');
                                            // $('.ant-select-selection').attr('aria-expanded', false)
                                        }
                                    }
                        >
                            <Form.Item
                                label={editUser.name.label}
                                required={editUser.name.required}
                            >
                                <Input
                                    placeholder={editUser.name.placeholder}
                                    value={editUser.name.value}
                                    onChange={e => onUserChange({name: e.target.value})}
                                    onKeyDown={(e)=>{
                                        if(e.keyCode === 13) {
                                            e.preventDefault()
                                        }
                                    }}
                                />
                            </Form.Item>

                            <Form.Item
                                label={editUser.account.label}
                                required={editUser.account.required}
                            >
                                <Input
                                    placeholder={editUser.account.placeholder}
                                    value={editUser.account.value}
                                    onChange={e => onUserChange({account: e.target.value})}
                                    disabled={!ifAdd}
                                    onKeyDown={(e)=>{
                                        if(e.keyCode === 13) {
                                            e.preventDefault()
                                        }
                                    }}
                                />
                            </Form.Item>

                            {
                                ifAdd ? <Form.Item
                                    label={editUser.password.label}
                                    required={editUser.password.required}
                                >
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <div style={{flex: "1"}}>
                                            <Input.Password
                                                placeholder={editUser.password.placeholder}
                                                value={editUser.password.value}
                                                onChange={e => onUserChange({password: e.target.value})}
                                                autoComplete="new-password"
                                                disabled={editUser.password.useDefaultValue}
                                                onKeyDown={(e)=>{
                                                    if(e.keyCode === 13) {
                                                        e.preventDefault()
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div style={{whiteSpace: "nowrap", marginLeft: 10}}>
                                            <Checkbox
                                                checked={editUser.password.useDefaultValue}
                                                onChange={e => {
                                                    editUser.password.useDefaultValue = e.target.checked;
                                                    this.setState({});
                                                }}
                                            >默认密码</Checkbox>
                                        </div>
                                    </div>
                                </Form.Item> : null
                            }

                            <Form.Item
                                label={editUser.sex.label}
                                required={editUser.sex.required}
                            >
                                <Radio.Group onChange={e => onUserChange({sex: e.target.value})}
                                             value={editUser.sex.value}>
                                    <Radio value={1}>男</Radio>
                                    <Radio value={2}>女</Radio>
                                </Radio.Group>
                            </Form.Item>
                            {/*部门按钮*/}
                            {
                                editUser && editUser.deptRoles && editUser.deptRoles.map((item, index) => {
                                    if (editUser.deptRoles.length <= 1) {
                                        item.status = 1;
                                    }
                                    if (index == editUser.deptRoles.length - 1) {
                                        return (
                                            <React.Fragment key={index}>
                                                {/*-部门开始-*/}
                                                <Form.Item
                                                    label={item.deptLabel}
                                                    required={item.required}
                                                    className={'iconSty'}
                                                    style={{cursor: `${item.status == 1 ? "" : editUser.deptRoles.length <= 1 ? "" : "not-allowed"}`}}
                                                >
                                                    <div style={{display: "flex", alignItems: "center",width:`${editUser.deptRoles.length<=1?'469px':""}`}}>
                                                        <div style={{flex: "1"}}>
                                                            <DeptSelectModal
                                                                disableAllDept={this.props.disableAllDept}//除了admin，其他禁用"全部"部门
                                                                isEnable={item.status == 1 ? true : editUser.deptRoles.length <= 1 ? true : false}
                                                                value={item.deptId}
                                                                handleOk={data => {
                                                                    editUser.deptRoles[index].deptId = data;
                                                                    this.setState({editUser})
                                                                }}
                                                                checkStrictly={true}
                                                                placeholder={"请选择所属部门"}
                                                                onItemDelete={() => {
                                                                }}
                                                                onDisableAllDeptCall={(data) => {
                                                                    if ((!data?.data?.fid || data?.data?.fid < 0) && this.props.disableAllDept && window.currentUser.account !== "admin") {
                                                                        return true
                                                                    } else {
                                                                        return false
                                                                    }
                                                                }}
                                                                treeCheckable={true}
                                                            />
                                                        </div>
                                                        <div style={{
                                                            display: 'flex',
                                                            marginBottom: editUser.deptRoles.length <= 1 ? 0 : -43,
                                                        }}>
                                                            <div>
                                                                <div style={{
                                                                    marginTop: editUser.deptRoles.length <= 1 ? 3 : 0,
                                                                    marginLeft: editUser.deptRoles.length <= 1 ? 10 : 0
                                                                }}>
                                                                    <Button style={{
                                                                        marginRight: 6,
                                                                        marginLeft: editUser.deptRoles.length <= 1 ? 8 : 18
                                                                    }}
                                                                            onClick={this.addDept}>添加</Button>
                                                                </div>
                                                                {
                                                                    editUser.deptRoles.length <= 1 ? null :
                                                                        <Popconfirm title="确定要删除吗？" okText="确定"
                                                                                    cancelText="取消"
                                                                                    onConfirm={() => this.delDept(index)}>
                                                                            <Button style={{
                                                                                marginTop: 3,
                                                                                marginLeft: 18,
                                                                                zIndex:9999
                                                                            }}>删除</Button>
                                                                        </Popconfirm>
                                                                }
                                                            </div>
                                                            {editUser.deptRoles.length <= 1 ? null : <Button
                                                                disabled={item.status === 1 && flag ? flag : false}
                                                                style={{
                                                                    marginLeft: editUser.deptRoles.length <= 1 ? 8 : 0,
                                                                    marginTop: editUser.deptRoles.length <= 1 ? 7 : 4
                                                                }}
                                                                onClick={() => this.statusChange(item, index)}>
                                                                {
                                                                    item.status === 1 ? '禁用' : "解禁"
                                                                }
                                                            </Button>}
                                                        </div>
                                                    </div>
                                                    <style>{`
                                                    .iconSty .value-select-wrap .close-btn{
                                                     display:none;
                                                    }
                                                    .iconSty .value-select-wrap .value-select-item{
                                                     border:none;
                                                     background-color:rgba(0,0,0,0);
                                                    }
                                                    `}</style>
                                                </Form.Item>
                                                <Form.Item
                                                    label={item.roleLabel}
                                                    required={item.required}
                                                >
                                                    <div style={{display: "flex", alignItems: "center",position:'relative',width:382}}>
                                                        <div style={{flex: "1"}} >
                                                            <RoleSelect
                                                                isEnable={item.status == 1 ? true : editUser.deptRoles.length <= 1 ? true : false}
                                                                mode="multiple"
                                                                value={item.roleCodes}
                                                                placeholder={"请选择用户角色"}
                                                                onChange={value => {
                                                                    // console.log('deptId', value);
                                                                    editUser.deptRoles[index].roleCodes = value;
                                                                    this.setState({editUser})
                                                                }}/>
                                                        </div>
                                                        <div style={{
                                                            position:'absolute',
                                                            top:'15px',
                                                            left:'381px',
                                                            height: 60,
                                                            width: 10,
                                                            border: '1px solid #ccc',
                                                            marginTop: -55,
                                                            marginRight: 142,
                                                            borderTopRightRadius: 5,
                                                            borderBottomRightRadius: 5,
                                                            zIndex: 0,
                                                            borderLeft: 'none'
                                                        }}/>
                                                    </div>
                                                </Form.Item>
                                                {/*-角色结束*/}
                                            </React.Fragment>
                                        )
                                    }
                                    return (
                                        <React.Fragment key={index}>
                                            <Form.Item
                                                label={item.deptLabel}
                                                required={item.required}
                                                className={'iconSty'}
                                                style={{cursor: `${item.status == 1 ? "" : editUser.deptRoles.length <= 1 ? "" : "not-allowed"}`}}
                                            >
                                                <div style={{display: "flex", alignItems: "center"}}>
                                                    <div style={{flex: "1"}}>
                                                        <DeptSelectModal
                                                            isEnable={item.status == 1 ? true : editUser.deptRoles.length <= 1 ? true : false}
                                                            value={item.deptId}
                                                            handleOk={data => {
                                                                let deptRoles = editUser.deptRoles;
                                                                deptRoles[index].deptId = data;
                                                                editUser.deptRoles = deptRoles;
                                                                this.setState({editUser})
                                                            }}
                                                            disableAllDept={this.props.disableAllDept}//除了admin，其他禁用"全部"部门
                                                            checkStrictly={true}
                                                            multiple={false}
                                                            placeholder={item.deptPlaceholder}
                                                            style={{zIndex: 1}}
                                                            onDisableAllDeptCall={(data) => {
                                                                //console.log("=======ssssssssssssssss==",data);
                                                                if ((!data?.data?.fid || data?.data?.fid < 0) && this.props.disableAllDept && window.currentUser.account !== "admin") {
                                                                    return true
                                                                } else {
                                                                    return false
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <div style={{marginTop: 3, marginLeft: 10}}>
                                                        <Button
                                                            disabled={item.status == 1 && flag ? flag : false}
                                                            style={{marginRight: 5, marginLeft: 8}}
                                                            onClick={() => this.statusChange(item, index)}>
                                                            {
                                                                item.status === 1 ? '禁用' : "解禁"
                                                            }
                                                        </Button>
                                                        <Popconfirm title="确定要删除吗？" okText="确定" cancelText="取消"
                                                                    onConfirm={() => this.delDept(index)}>
                                                            <Button>删除</Button>
                                                        </Popconfirm>
                                                    </div>
                                                </div>
                                            </Form.Item>

                                            <Form.Item
                                                label={item.roleLabel}
                                                required={item.required}
                                            >
                                                <div style={{display: "flex", alignItems: "center",position:'relative',width:382}}>
                                                    <div style={{flex: "1"}}>
                                                        <RoleSelect
                                                            isEnable={item.status == 1 ? true : editUser.deptRoles.length <= 1 ? true : false}
                                                            mode="multiple"
                                                            value={item.roleCodes}
                                                            placeholder={"请选择用户角色"}
                                                            onChange={value => {
                                                                let deptRoles = editUser.deptRoles;
                                                                deptRoles[index].roleCodes = value;
                                                                editUser.deptRoles = deptRoles;
                                                                this.setState({editUser})
                                                            }}
                                                        />
                                                    </div>
                                                    <div style={{
                                                        position:'absolute',
                                                        top:'15px',
                                                        left:'381px',
                                                        height: 60,
                                                        width: 10,
                                                        border: '1px solid #ccc',
                                                        marginTop: -55,
                                                        marginRight: 142,
                                                        borderTopRightRadius: 5,
                                                        borderBottomRightRadius: 5,
                                                        zIndex: 0,
                                                        borderLeft: 'none'
                                                    }}/>
                                                </div>
                                            </Form.Item>
                                        </React.Fragment>
                                    )
                                })
                            }
                            <Form.Item
                                label={editUser.phone.label}
                                required={editUser.phone.required}
                            >
                                <Input
                                    placeholder={editUser.phone.placeholder}
                                    value={editUser.phone.value}
                                    onChange={e => onUserChange({phone: e.target.value})}
                                />
                            </Form.Item>
                            <Form.Item
                                label={editUser.tel.label}
                                required={editUser.tel.required}
                            >
                                <Input
                                    placeholder={editUser.tel.placeholder}
                                    value={editUser.tel.value}
                                    onChange={e => onUserChange({tel: e.target.value})}
                                />
                            </Form.Item>
                            {
                                webSiteDataSource && webSiteDataSource.length ? <Form.Item
                                    label={editUser.website.label}
                                    required={editUser.website.required}
                                >
                                    <div style={{display: 'flex', flexWrap: 'wrap',}}>
                                        {
                                            webSiteDataSource.map((item,Index) => {
                                                let name = item.mediaName + (item.vsbUserName ? `（已绑定${item.vsbUserName}）` : `（未绑定）`);
                                                return (
                                                    <Tooltip placement="topLeft" title={name} key={Index}>
                                                    <div key={item.mediaId} className={"text-pointer"} style={{
                                                        height: 30,
                                                        width: 165,
                                                        lineHeight: '30px',
                                                        fontSize: '12px',
                                                        cursor: 'pointer',
                                                        background: this.themeBgColor,
                                                        borderRadius: 5,
                                                        padding: '0 10px',
                                                        color: '#fff',
                                                        marginRight: 10,
                                                        marginBottom: 10
                                                    }} onClick={() => {
                                                        this.binding(item, editUser);
                                                    }}>{name}</div>
                                                    </Tooltip>
                                                )
                                            })
                                        }
                                    </div>
                                </Form.Item> : null
                            }
                        </Scrollbars>
                    </CmForm>
                    <style>{`
                    .ant-form-item-label > label::after {
                      content: '：';
                    }
                   `}
                    </style>
                </CmModal>
                <div
                    onKeyDown={(e)=>{
                    e.stopPropagation();
                }}
                ><SelectUserModal ref={ref => this.selectUserModal = ref}/></div>
            </>
        );
    }

    binding(item, editUser) {
        this.selectUserModal.showModal(false, item, editUser,()=>{
            this.props.refresh&&this.props.refresh()
        });
    };

    // 添加按钮
    addDept = () => {
        const {editUser} = this.state;
        editUser.deptRoles.push({
            deptLabel: '部门',
            deptId: "",
            roleLabel: '角色',
            roleCodes: [],
            status: 1,
            required: true
        });
        this.setState({editUser})
    };
    // 删除
    delDept = (index) => {
        const {editUser} = this.state;
        if (editUser.deptRoles.length > 1) {
            editUser.deptRoles.splice(index, 1)
        } else {
            message.error('至少需要一个部门和角色！')
        }
        this.setState({editUser})
    };

    // 状态切换
    statusChange(item, index) {
        let deptRoles = this.state.editUser.deptRoles;
        let status = item.status;
        deptRoles[index].status = status == 1 ? 0 : 1;
        this.state.editUser.deptRoles = deptRoles;
        this.setState({});
        console.log('------',this.state.editUser.deptRoles);
    }

    // 确定
    handleOk = () => {
        const {editUser} = this.state;
        const data = {};
        let editUserKeys = Object.keys(editUser);
        if (editUser.id.value) {
            // 修改不提交密码
            editUserKeys = editUserKeys.filter(item => item !== "password");
        }
        for (let i = 0; i < editUserKeys.length; i++) {
            const key = editUserKeys[i];
            // 使用默认密码
            if (key === "password" && editUser[key].useDefaultValue) {
                data[key] = "";
                continue;
            }
            if (editUser[key].value) {
                console.log(editUser[key], "--------", editUser[key].value)
                data[key] = editUser[key].value;
            }
            if (editUser[key].check && !editUser[key].check(editUser[key].value)) {
                return;
            }
        }
        if (editUser.deptRoles) {
            let deptRoles = editUser.deptRoles;
            for (let j = 0; j < deptRoles.length; j++) {
                if (!deptRoles[j].deptId || !deptRoles[j].roleCodes.length) {
                    // deptRoles[j].check();
                    message.error("请选择部门和角色！");
                    return false;
                }
            }
        }
        data.deptRoles = editUser.deptRoles;
        let flag = false;
        let num = 0;
        data.deptRoles && data.deptRoles.length && data.deptRoles.map((item, index) => {
            data.deptRoles.map((Item, Index) => {
                if (index !== Index) {
                    if (item.deptId == Item.deptId) {
                        flag = true;
                    }
                }
            });
            if(item.status==0){
                num++;
            }
        });
        if (flag) {
            message.error('选择部门不能重复！');
            return
        }
        if (num >= 2 && editUser.deptRoles.length <= 2) {
            message.error('至少有一个部门不能禁用！');
            return
        }
        this.props.handleOk(data);
    };

    handleCancel = () => {
        this.props.handleCancel();
    };

    onUserChange = data => {
        const {editUser} = this.state;
        Object.keys(data).forEach(key => {
            editUser[key].value = data[key];
        });
        this.setState({});
    };
}

// 初始化表单数据
function initUser(
    {
        deptIds = [],
        account = "",
        name = "",
        roleCodes = [],
        password = "",
        sex = 1,
        tel = "",
        phone = "",
        photoUrl = "",
        id = "",
        deptRoles = [
            {
                deptId: '',
                roleCodes: [],
                status: 1
            }
        ]
    } = {}, level
) {

    const editUser = {
        id: {
            value: id
        },
        name: {
            required: true,
            value: name,
            label: "姓名",
            placeholder: "请输入用户姓名",
            check: value => {
                value = value.trim();
                if (!value) {
                    message.error("姓名不能为空！");
                    return false;
                }
                if (!validateName(value, {min: 1, max: 50})) {
                    message.error("姓名为1-50个字符,可使用中文、数字、字母、下划线！");
                    return false;
                }
                return true;
            }
        },
        account: {
            value: account,
            label: "账号",
            required: true,
            placeholder: "请输入用户账号",
            check: accountValidate
        },
        password: {
            required: true,
            value: password,
            useDefaultValue: false,
            placeholder: "请输入密码",
            label: "密码",
            check: value => {
                if (!value) {
                    message.error("密码不能为空！");
                    return false;
                }
                if (level === "0") {
                    if (!(/^[0-9a-zA-Z._~!@#$^&*]{7,20}$/.test(value))) {
                        message.error("密码为7-20字符，可使用数字，字母，特殊字符（._~!@#$^&*）！");
                        return false;
                    }
                } else if (level === "1") {
                    if (!(/((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[\u4E00-\u9FA5].*$)^\S{7,20}$/.test(value))) {
                        message.error("密码为7-20字符，至少包含2种字符格式，可使用数字，字母，特殊字符（._~!@#$^&*）！");
                        return false;
                    }
                } else if (level === "2") {
                    if (!(/(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%&*~()-+=]+$)(?![0-9\\W_!@#$%^&*()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`()-+=]{6,30}$/.test(value))) {
                        message.error("密码为7-20字符，至少包含3种字符格式，可使用数字，字母，特殊字符（._~!@#$^&*）！");
                        return false;
                    }
                }
                // if (!(/^[0-9a-zA-Z._~!@#$^&*]{7,20}$/.test(value))) {
                //     message.error("密码为7-20字符，可使用数字，字母，特殊字符（._~!@#$^&*）！");
                //     return false;
                // }
                return true;
            }
        },
        /*        deptIds: {
                    required: true,
                    value: deptIds,
                    label: "部门",
                    placeholder: "请选择所属部门",
                    check: value => {
                        let check = true;
                        if (value.length < 1) {
                            check = false;
                            message.error("请至少选择一个部门");
                        }
                        return check;
                    }
                },
                roleCodes: {
                    required: true,
                    value: roleCodes,
                    label: "角色",
                    placeholder: "请选择用户角色",
                    check: value => {
                        let check = true;
                        if (value.length < 1) {
                            check = false;
                            message.error("请至少选择一个角色");
                        }
                        return check;
                    }
                },*/

        sex: {
            required: false,
            value: sex,
            label: "性别"
        },
        tel: {
            required: false,
            value: tel,
            label: "办公电话",
            placeholder: "请输入办公电话",
            check: value => {
                let telRegexp = new RegExp("^[0][0-9]{2,3}-[0-9]{5,10}$");
                let telRegexp_1 = new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{4}$");
                let telRegexp_ = new RegExp("^[1-9]{1}[0-9]{5,10}$");
                if (value && value.length > 0 && !telRegexp.test(value) && !telRegexp_.test(value) && !telRegexp_1.test(value) && (!/^[\d]{2}[*]{3,9}[\d]{2}$/.test(value))) {
                    message.error("办公电话格式不正确！");
                    return;
                }
                return true;
            }
        },
        website: {
            required: false,
            label: "绑定网站用户",
        },
        phone: {
            required: false,
            value: phone,
            label: "手机",
            placeholder: "请输入手机号",
            check: value => {
                if (value) {
                    // ^1[3456789]\d{3}\d{4}(\d{4})$
                    if (!/^1[3456789][\d][\d*]{4}\d{4}$/.test(value)) {
                        message.error("手机格式错误！");
                        return false;
                    }
                }
                return true;
            }
        },
        photoUrl: {
            required: false,
            value: photoUrl,
            label: "上传头像"
        },
        deptRoles: [
            /*{
                deptLabel: '部门',
                deptPlaceholder:'请选择部门',
                deptId: '',
                roleLabel: '角色',
                roleCodePlaceholder:'请选择角色',
                roleCodes: [],
                status: 1,
                required:true,
                check:()=>{
                    message.error("请选择部门和角色");
                }
            }*/
        ]
    };

    let itemDeptRole = {
        deptLabel: '部门',
        deptPlaceholder: '请选择所属部门',
        deptId: '',
        roleLabel: '角色',
        roleCodePlaceholder: '请选择用户角色',
        roleCodes: [],
        status: 1,
        required: true,
        check: () => {
            message.destroy();
            message.error("请选择部门和角色！");
        }
    };
    let getdeptRoles = deptRoles;
    console.log("==============",getdeptRoles)
    for (let i = 0; i < getdeptRoles.length; i++) {
        editUser.deptRoles.push({
            ...itemDeptRole,
            ...getdeptRoles[i]
        })
    }
    // console.log(editUser.deptRoles)
    return editUser;
}